var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { transient, autoinject } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-pal';
import { Router } from 'aurelia-router';
import { EventAggregator } from 'aurelia-event-aggregator';
import { I18N } from 'aurelia-i18n';
import { BaseBundle } from '../../templates/base-bundle';
import { ClientLotteryClientService } from '../../../../services/modules/client/client-lottery-client-service';
import { NotificationClientService } from '../../../../services/basics/notification-client.service';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
import { BindingSignaler } from 'aurelia-templating-resources';
import { GamePlayerTicketClientService } from '../../../../services/modules/client/client-game-player-ticket-client.service';
var RenderBundleSectioned = /** @class */ (function (_super) {
    __extends(RenderBundleSectioned, _super);
    function RenderBundleSectioned(lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) {
        var _this = _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, eventAggregator, dialogClientService, bindingSignaler, gamePlayerTicketClientService) || this;
        _this.sections = [];
        return _this;
    }
    RenderBundleSectioned_1 = RenderBundleSectioned;
    RenderBundleSectioned.prototype.activate = function (params) {
        this.loadSections();
        return _super.prototype.activate.call(this, params);
    };
    RenderBundleSectioned.prototype.loadSections = function () {
        var _this = this;
        try {
            var server = window.server;
            var layout = server && server.renderLayout ? server.renderLayout : null;
            var bundle = layout && layout.bundle ? layout.bundle : null;
            if (bundle && bundle.length) {
                this.sections = bundle
                    .filter(function (s) { return s.visible !== false; })
                    .map(function (s) { return _this.prepareRow(s); })
                    .filter(function (s) { return _this.isRow(s) ? s.children.length > 0 : !!_this.blockModule(s); })
                    .sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
            }
        }
        catch (_a) {
            this.sections = [];
        }
    };
    RenderBundleSectioned.prototype.isRow = function (section) {
        return !!section && section.type === 'Row';
    };
    RenderBundleSectioned.prototype.prepareRow = function (section) {
        var _this = this;
        if (this.isRow(section)) {
            section.children = (section.children || []).filter(function (c) { return c.visible !== false && !!_this.blockModule(c); });
        }
        return section;
    };
    Object.defineProperty(RenderBundleSectioned.prototype, "shell", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    RenderBundleSectioned.prototype.blockModule = function (section) {
        if (!section) {
            return null;
        }
        var variant = section.variant || RenderBundleSectioned_1.defaultVariantForType[section.type];
        return variant ? RenderBundleSectioned_1.variantModules[variant] : null;
    };
    RenderBundleSectioned.prototype.getAdImage = function (props) {
        var size = this.size;
        if (props && props.image && props.image[size]) {
            return props.image[size];
        }
        if (props && props.imageKey) {
            return this.i18n.tr(this.key + '-' + props.imageKey + '-' + size);
        }
        return '';
    };
    RenderBundleSectioned.prototype.getAdLink = function (props, element) {
        if (props && props.link) {
            return this.resolveAdUrl(props.link, element);
        }
        if (props && props.linkKey) {
            return this.getAd(this.key + '-' + props.linkKey + '-' + this.size, element);
        }
        return '';
    };
    var RenderBundleSectioned_1;
    RenderBundleSectioned.variantModules = {
        'bundle-details-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/bundle-details/bundle-details'),
        'bundle-details-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/bundle-details-t3/bundle-details-t3'),
        'bundle-game-information-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/bundle-game-information/bundle-game-information'),
        'advert-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/advert/advert'),
        'banners-custom': PLATFORM.moduleName('app/styles/client/render-engine/blocks/banners-custom/banners-custom'),
    };
    RenderBundleSectioned.defaultVariantForType = {
        BundleDetails: 'bundle-details-t7',
        BundleGameInformation: 'bundle-game-information-t7',
        Advert: 'advert-t7',
    };
    RenderBundleSectioned = RenderBundleSectioned_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, EventAggregator, DialogClientService,
            BindingSignaler, GamePlayerTicketClientService])
    ], RenderBundleSectioned);
    return RenderBundleSectioned;
}(BaseBundle));
export { RenderBundleSectioned };
